export default __webpack_public_path__ + "static/media/ChildCareCenter1.789d27a2.png";